import React, { Component } from "react";

import { Form, Button, Input, Checkbox, Row, Col, Spin, Select } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import VehicleGroupStore from "../store/VehicleGroupStore";
import withRouter from "../withRouter";

import CompanyAutocomplete from "./CompanyAutocomplete";

import CompanyStore from "../store/CompanyStore";
import DriversStore from "../store/DriversStore";
import config from "../config";

const CheckboxGroup = Checkbox.Group;

class VehicleGroupAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showAsset: false,
      selectedChecked: false,
      selectedValues: [],
      deviceGroupId: "",
      companyId: "",
      loadingSpin: false,
      driverId: '',
    };
    this.groupStore = new VehicleGroupStore();
    this.companyStore = new CompanyStore();
    this.driverStore = new DriversStore();

  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ isadmin: this.props.getUserData().isadmin });
      await this.groupStore.getAssetData(
        this.props.getUserData().userCompanyId
      );
      await this.driverStore.toGetDriverName(
        this.props.getUserData().userCompanyId
      );

      await this.setState({ update: 1 });
    }
    const deviceGroupId = this.props.vehicleGroupId;

    if (deviceGroupId) {
      await this.filldata(deviceGroupId);
      await this.setState({ deviceGroupId: deviceGroupId });
    }
  }

  filldata = async (deviceGroupId) => {
    await this.setState({ loadingSpin: true });
    const getVehicleGroup = await this.groupStore.getVehicleGroupData(
      deviceGroupId,
      this.props.companyId
    );

    const allVehicles = await this.groupStore.getAssetData(
      this.props.companyId
    );

    const singleData = await this.companyStore.getCompanyDataById(
      this.props.companyId
    );
    let driverResp = await this.driverStore.toGetDriverName(
      this.props.companyId
    );

    await this.setState({
      companyId: getVehicleGroup.companyId,
      deviceGroupId: getVehicleGroup.deviceGroupId,
    });

    let vehicleData = [];
    getVehicleGroup.vehicles?.forEach((val) => {
      vehicleData.push(val.vehicleId);
    });
    if (vehicleData.length === allVehicles.length) {
      this.setState({ selectedChecked: true });
    }

    await this.setState({ selectedValues: vehicleData });

    await this.formRef.current.setFieldsValue({
      deviceGroupId: getVehicleGroup.deviceGroupId,
      companyId: singleData,
      groupname: getVehicleGroup.groupname,
      inchargeName: getVehicleGroup.inchargeName,
      email: getVehicleGroup.email,
      driverId: getVehicleGroup.driverId,
      // vehicle: this.state.selectedValues,
    });
    await this.setState({ loadingSpin: false });
  };

  onDeviceDetailsSubmit = async (values) => {
    this.setState({ loading: true });
    console.log(values)
    const data = {
      ...values,
      companyId: this.state.companyId,
      devicegroupId: this.state.deviceGroupId,
      deviceGroupparentId: 0,
      // devicegroupId: "",
      tokenId: "",
      vehicle: this.state.selectedValues,
      // driverId: this.state.driverId,
    };
    console.log(data);
    const resp = await this.groupStore.addData(data);
    await this.props.response(resp);
    // if (resp.data.success == "S") {
    //   message.success(resp.data.message);
    //   this.props.navigate("/vehiclegrouplist");
    // } else if (resp.data.success == "F0") {
    //   resp.data.errors.map((value) => {
    //     message.error(value["username"]);
    //   });
    // }
    this.setState({ loading: false });
  };

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleGroupId) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: comp.value,
      });
    }
    await this.formRef.current.setFieldsValue({
      companyId: this.state.companyId,
    });
    await this.driverStore.toGetDriverName(comp.value);


    const data = await this.groupStore.getAssetData(this.state.companyId);
    console.log("data", data);
    await this.handleSearch();
  }

  async handleSearch() {
    await this.groupStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }

  handleSelectAllChange = async (e) => {
    this.setState({ selectedChecked: e.target.checked });

    if (e.target.checked) {
      const allValues = this.groupStore?.assetList.map(
        (option) => option.vehicleId
      );
      this.formRef.current.setFieldsValue({ vehicle: allValues.vehicleNo });

      await this.setState({ selectedValues: allValues });
    } else {
      await this.setState({ selectedChecked: e.target.checked });
      await this.setState({ selectedValues: [] });
    }
  };

  handleCheckboxChange = async (checkedValues) => {
    if (checkedValues?.length === this.groupStore.assetList.length) {
      console.log("hoo");
      await this.setState({ selectedChecked: true });
    } else {
      await this.setState({ selectedChecked: false });
    }
    await this.setState({ selectedValues: checkedValues });

    console.log(this.state.selectedValues);
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <div style={{ padding: 0 }}>
        <div>
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              style={{ maxWidth: "100%", padding: 0 }}
              layout="vertical"
              ref={this.formRef}
              onFinish={this.onDeviceDetailsSubmit}
              name="nest-message"
              className="formClass" //change
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {/* css class */}
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <Form.Item
                        name="companyId"
                        label={this.context.translate("_ACCOUNT_")}
                        rules={[{ required: true }]}
                      >
                        <CompanyAutocomplete
                          onChange={(value) => this.handleChange(value)}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    )}

                  <Form.Item
                    name="groupname"
                    label={this.context.translate(
                      "_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_"
                    )}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="inchargeName"
                    label={this.context.translate("_INCHARGE_NAME_")}
                  >
                    <Input />
                  </Form.Item>
                  {config.project === "starlingeye" &&
                    <Form.Item
                      style={{ width: "100%" }}
                      value={this.state.driverId}
                      name="driverId"
                      label={this.context.translate("_DRIVER_NAME_")}
                    // rules={[{ required: true }]}
                    >
                      <Select
                        disabled={this.props.allocateVehicleId ? true : false}
                        placeholder={this.context.translate(
                          "_SELECT_DRIVER_"
                        )}
                        // onChange={(e) => this.setFieldsValues(e)}
                        showSearch
                        fieldNames={{ value: "driverId", label: "name" }}
                        optionFilterProp="children"
                        options={this.driverStore?.getDriverName}
                        filterOption={(input, option) => {
                          console.log(input)
                          if (!option?.name) return false;

                          const label = option.name
                            .toString()
                            .toLowerCase()
                            .replace(/\s+/g, ""); // remove spaces

                          const search = input
                            .toLowerCase()
                            .replace(/\s+/g, "");

                          return label.includes(search);
                        }}
                      />
                    </Form.Item>
                  }

                </Col>
                <Col span={12} className="formColumnClass">
                  {/* css class */}
                  <Form.Item
                    name="email"
                    label={this.context.translate("_EMAIL_")}
                    rules={[{ type: "email" }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item label=" ">
                    {this.context.translate(
                      "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                    )}
                    &nbsp;&nbsp;
                    <Checkbox
                      checked={this.state.selectedChecked}
                      onChange={(e) => {
                        this.handleSelectAllChange(e);
                      }}
                    >
                      {this.context.translate("_ALL_")}
                    </Checkbox>
                  </Form.Item>

                  <CheckboxGroup
                    name="vehicle"
                    value={this.state.selectedValues}
                    onChange={this.handleCheckboxChange}
                  >
                    <Row>
                      {this.groupStore?.assetList?.map((value) => {
                        return (
                          <Col span={10}>
                            <Checkbox value={value.vehicleId}>
                              {value.vehicleNo}
                            </Checkbox>
                          </Col>
                        );
                      })}
                    </Row>
                  </CheckboxGroup>
                </Col>
              </Row>
              <div className="formBtnGroup">
                <Button
                  type="primary"
                  className="formCancelButton"
                  onClick={(e) => {
                    // this.formRef.current?.resetFields();
                    this.closeModal();
                    this.setState({
                      selectedChecked: false,
                      selectedValues: [],
                    });
                  }}
                >
                  {this.context.translate("_FLEET_CLOSE_BTN_")}
                </Button>
                <Button
                  type="primary"
                  className="formSaveButton"
                  htmlType="submit"
                  loading={this.state.loading}
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}

VehicleGroupAdd.contextType = StoreContext;
export default observer(withRouter(VehicleGroupAdd));
